import gql from 'graphql-tag'
export default gql`query environmentClassQuery($id: Int!) {
  environmentClass(id: $id) {
    code
    description
    minCement
    maxWbf
    requirementMax
    deviationMax
    maxDeviationsAllowed
    minimumAirPercentages {
      largestGrain
      airPercentage
    }
    encroachment
    id
  }
}`